import React from 'react';
import { SvgIcon } from '@mui/material';

export default function CalendarAccentIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 17" sx={{ width: 16, height: 17 }} {...props}>
      <rect y="0.5" width="16" height="16" rx="4" fill="white" />
      <rect
        x="7.30469"
        y="4.5"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="10.75"
        y="4.5"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="3.85938"
        y="4.5"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="7.30469"
        y="7.80542"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="10.75"
        y="7.80542"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="3.85938"
        y="7.80542"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="7.30469"
        y="11.1113"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="10.75"
        y="11.1113"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
      <rect
        x="3.85938"
        y="11.1113"
        width="1.38889"
        height="1.38889"
        rx="0.694444"
        fill="#4520AB"
      />
    </SvgIcon>
  );
}
